import React, { useState } from "react";
import { Link } from "react-router-dom";

const ProjectGrid = ({ projects }) => {
  const [loadedImages, setLoadedImages] = useState({});

  const handleImageLoad = (projectId) => {
    setLoadedImages((prev) => ({
      ...prev,
      [projectId]: true,
    }));
  };

  return (
    <div
      id="projects"
      className="mx-auto py-16 md:py-24"
      style={{ width: "var(--content-w, 100%)", maxWidth: "100%" }}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {projects.map((project, index) => (
          <Link
            key={index}
            to={`/project/${project.id}`}
            className="relative group overflow-hidden"
          >
            <div className="aspect-w-16 aspect-h-9">
              {/* Loading state placeholder */}
              {!loadedImages[project.id] && (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
                  <div className="h-8 w-8 rounded-full border-t-2 border-b-2 border-gray-500 animate-spin"></div>
                </div>
              )}
              <img
                src={project.thumbnail}
                alt={project.title}
                className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                  loadedImages[project.id] ? "opacity-100" : "opacity-0"
                } transition-opacity duration-300`}
                onLoad={() => handleImageLoad(project.id)}
              />
            </div>

            {/* Hover overlay - HARDCODED dark, NOT theme-dependent */}
            <div
              className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}
            />

            <div className="absolute bottom-0 left-0 p-4 w-full">
              <h3 className="text-xl font-display font-bold text-overlay-white">
                {project.title}
              </h3>
              <p className="text-sm font-sans tracking-wider text-overlay-light">
                {project.subtitle}
              </p>
              <p className="text-sm font-sans tracking-wider text-overlay-light">
                {project.role}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ProjectGrid;
